import { render, staticRenderFns } from "./JVxePagination.vue?vue&type=template&id=ea9dae5e&scoped=true&"
import script from "./JVxePagination.vue?vue&type=script&lang=js&"
export * from "./JVxePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9dae5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea9dae5e')) {
      api.createRecord('ea9dae5e', component.options)
    } else {
      api.reload('ea9dae5e', component.options)
    }
    module.hot.accept("./JVxePagination.vue?vue&type=template&id=ea9dae5e&scoped=true&", function () {
      api.rerender('ea9dae5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JVxeTable/components/JVxePagination.vue"
export default component.exports